export default __webpack_public_path__ + "static/media/truck_1_1.2950e3bf.svg";